export default {
    '1': 'Yanlış ürün sipariş edildi',
    '2': 'Yinelenen sipariş',
    '3': 'Teslim alınamıyor',
    '4': 'Diğer nedenler',
    '-连接已建立-': '-Bağlantı kuruldu-',
    ',才可提币': ', ancak o zaman çekim yapılabilir',
    '[code]值错误': '[code] değeri hatalı',
    '[symbol]参数为空': '[symbol] parametresi boş',
    homeDownloadtips41: 'Satıcı Uygulaması',
    '不能为空': 'Boş olamaz',
    '不在交易时段': 'İşlem saatleri dışında',
    '不在可提现时间内': 'Çekim saatleri dışında',
    '参数错误': 'Parametre hatası',
    '参数异常，消息获取失败': 'Parametre anormal, mesaj alınamadı',
    '操作成功': 'İşlem başarılı',
    '操作类型不能小于0': 'İşlem türü 0\'dan küçük olamaz',
    '操作类型不是整数': 'İşlem türü tam sayı değil',
    '操作类型为空': 'İşlem türü boş',
    '产品不存在': 'Ürün mevcut değil',
    '产品剩余数量不足': 'Kalan ürün miktarı yetersiz',
    '承兑商不存在': 'Satıcı mevcut değil',
    '程序错误': 'Program hatası',
    '持有币种不足': 'Sahip olunan para birimi yetersiz',
    '充值价值不得大于最大限额': 'Yükleme değeri maksimum limiti aşamaz',
    '充值价值不得小于最小限额': 'Yükleme değeri minimum limitin altında olamaz',
    '充值链错误': 'Yükleme zinciri hatası',
    '充值数量不能小于等于0': 'Yükleme miktarı 0\'dan küçük veya eşit olamaz',
    '存在不同杠杆的持仓单': 'Farklı kaldıraçlı pozisyonlar mevcut',
    '存在重复的角色名称': 'Yinelenen rol adı mevcut',
    '大于最大采购数量': 'Maksimum satın alma miktarından fazla',
    '代理层级错误': 'Acente seviyesi hatası',
    '待付款的订单无法放行': 'Ödeme bekleyen sipariş serbest bırakılamaz',
    '当前地址格式错误': 'Geçerli adres formatı hatalı',
    '当前订单不为待付款状态，无法取消': 'Sipariş ödeme bekliyor durumunda değil, iptal edilemez',
    '当前还需交易': 'Hâlâ daha fazla işlem gerekiyor',
    '当日才可申购': 'Abonelik yalnızca aynı gün yapılabilir',
    '当日可提现次数不足': 'Bugünkü çekim sayısı yetersiz',
    '登陆密码不符合设定': 'Giriş şifresi gereksinimleri karşılamıyor',
    '登陆密码长度不符合设定': 'Giriş şifresi uzunluğu gereksinimleri karşılamıyor',
    '登录过期，请重新登录': 'Oturum süresi doldu, lütfen tekrar giriş yapın',
    '登录密码必须6-12位': 'Giriş şifresi 6-12 karakter olmalıdır',
    '登录密码不能为空': 'Giriş şifresi boş olamaz',
    '登录失败': 'Giriş başarısız',
    '电话号码已绑定': 'Telefon numarası zaten bağlı',
    '电话号码已绑定其他用户': 'Telefon numarası zaten başka bir kullanıcıya bağlı',
    '订单不存在': 'Sipariş mevcut değil',
    '订单已取消': 'Sipariş iptal edildi',
    '订单已取消，无法放行': 'Sipariş iptal edildi, serbest bırakılamaz',
    '订单已完成，无法放行': 'Sipariş tamamlandı, serbest bırakılamaz',
    '发现新版本，请升级到最新版本': 'Yeni sürüm bulundu, lütfen en son sürüme güncelleyin',
    '服务器错误': 'Sunucu hatası',
    '服务器错误(500)': 'Sunucu hatası (500)',
    '该产品未上架': 'Bu ürün listelenmemiş',
    '该产品已上市，无法购买': 'Bu ürün zaten listelenmiş, satın alınamaz',
    '该订单已取消': 'Bu sipariş iptal edildi',
    '该广告剩余数量不足': 'Bu ilanın kalan miktarı yetersiz',
    '该基金尚未开放购买': 'Bu fon henüz satın almaya açık değil',
    '该基金尚已封闭': 'Bu fon zaten kapatıldı',
    '该邮箱已被订阅': 'Bu e-posta zaten abone',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Format hatası: yükleme tutarı 1\'den az olamaz (iki ondalık)',
    '跟单倍数输入错误': 'Kopya işlem çarpanı girişi hatalı',
    '跟单参数输入错误': 'Kopya işlem parametreleri girişi hatalı',
    '更新提醒': 'Güncelleme hatırlatması',
    '工作地址不能为空': 'İş adresi boş olamaz',
    '购买矿机时间不得低于托管订单剩余时间': 'Madenci satın alma süresi, barındırma siparişinin kalan süresinden az olamaz',
    '广告不存在': 'İlan mevcut değil',
    '广告已下架': 'İlan kaldırıldı',
    '基金剩余购买金额不足': 'Fonun kalan satın alma tutarı yetersiz',
    '家庭地址不能为空': 'Ev adresi boş olamaz',
    '交易员不存在': 'İşlemci mevcut değil',
    '交易员不能跟随自己': 'İşlemci kendini takip edemez',
    '交易员跟随人数已满': 'İşlemcinin takipçi sayısı dolu',
    '交易员未开启带单': 'İşlemci kopya işlemi etkinleştirmemiş',
    '交易员无法跟随另一个交易员': 'Bir işlemci başka bir işlemciyi takip edemez',
    '角色被用户关联，不可删除': 'Rol kullanıcılara bağlı, silinemez',
    '角色不存在': 'Rol mevcut değil',
    '金额不在购买区间': 'Tutar satın alma aralığında değil',
    '金额错误': 'Tutar hatası',
    '旧密码不能为空': 'Eski şifre boş olamaz',
    '旧密码不正确': 'Eski şifre yanlış',
    '可平仓合约张数不足': 'Kapatılabilir sözleşme sayısı yetersiz',
    '矿机不存在': 'Madenci mevcut değil',
    '矿机未解锁，无法购买': 'Madenci kilidi açılmamış, satın alınamaz',
    '历史基金无法购买': 'Geçmiş fonlar satın alınamaz',
    '连续输入错误三次，请3分钟后再试': 'Üst üste üç kez yanlış girildi, lütfen 3 dakika sonra tekrar deneyin',
    '领取成功': 'Başarıyla alındı',
    '买入金额需要在区间内': 'Satın alma tutarı aralık içinde olmalı',
    '卖方无法取消该订单': 'Satıcı bu siparişi iptal edemez',
    '没有找到用户': 'Kullanıcı bulunamadı',
    verificationCode: 'Doğrulama kodu',
    pleaseEnterVerificationCode: 'Lütfen doğrulama kodunu girin',
    pleaseEnterUsername: 'Lütfen kullanıcı adını girin',
    username: 'Kullanıcı adı',
    getVerificationCode: 'Kod al',
    tryAgainLater: 'saniye sonra tekrar deneyin',
    '密码必须6-12位': 'Şifre 6-12 karakter olmalıdır',
    '密码不能为空': 'Şifre boş olamaz',
    '密码不正确': 'Şifre yanlış',
    '您当前可分配额度不足': 'Mevcut atanabilir limitiniz yetersiz',
    '您没有符合条件的收款方式': 'Uygun bir ödeme alma yönteminiz yok',
    '您已存在订单': 'Zaten bir siparişiniz var',
    '您已购买过体验矿机,不得重复购买': 'Zaten bir deneme madencisi satın aldınız, tekrar satın alamazsınız',
    '亲属地址不能为空': 'Yakın adresi boş olamaz',
    '亲属电话不能为空': 'Yakın telefonu boş olamaz',
    '亲属关系不能为空': 'Yakınlık derecesi boş olamaz',
    '亲属姓名不能为空': 'Yakın adı boş olamaz',
    '请检查网络连接': 'Lütfen ağ bağlantısını kontrol edin',
    '请上传图片': 'Lütfen bir resim yükleyin',
    '请稍后再试': 'Lütfen daha sonra tekrar deneyin',
    '请稍后重试': 'Lütfen daha sonra tekrar deneyin',
    '请输入充值币种': 'Lütfen yükleme para birimini girin',
    '请输入内容': 'Lütfen içeriği girin',
    '请输入搜索关键字': 'Lütfen arama anahtar kelimesini girin',
    '请输入正确的货币数量': 'Lütfen doğru para birimi miktarını girin',
    '请输入正确的金额': 'Lütfen doğru tutarı girin',
    '请输入正确的数量': 'Lütfen doğru miktarı girin',
    '请输入正确的质押金额': 'Lütfen doğru staking tutarını girin',
    '请输入正确的质押天数': 'Lütfen doğru staking gün sayısını girin',
    '请填写正确的电话号码': 'Lütfen doğru telefon numarasını girin',
    '请填写正确的验证码': 'Lütfen doğru doğrulama kodunu girin',
    '请填写正确的邮箱地址': 'Lütfen doğru e-posta adresini girin',
    '请先绑定谷歌验证器': 'Lütfen önce Google Authenticator\'ı bağlayın',
    '请先添加收款方式': 'Lütfen önce bir ödeme alma yöntemi ekleyin',
    '请先通过高级认证': 'Lütfen önce gelişmiş doğrulamayı tamamlayın',
    '请选择买卖方式': 'Lütfen alım/satım yöntemini seçin',
    '请选择正确的币种': 'Lütfen doğru para birimini seçin',
    '请重新登录': 'Lütfen tekrar giriş yapın',
    '渠道未开通': 'Kanal etkinleştirilmemiş',
    '取消': 'İptal',
    '确认': 'Onayla',
    '申购数量错误': 'Abonelik miktarı hatalı',
    '申请成功': 'Başvuru başarılı',
    '身份证已实名过!': 'Kimlik zaten doğrulandı!',
    '审核已通过': 'İnceleme onaylandı',
    '审核中': 'İnceleniyor',
    '实名认证未通过，无法进行高级认证': 'Kimlik doğrulaması geçmedi, gelişmiş doğrulama yapılamıyor',
    '收款方输入错误': 'Alıcı girişi hatalı',
    '授权状态未成功': 'Yetkilendirme durumu başarısız',
    '赎回状态异常': 'İtfa durumu anormal',
    '所选汇率不存在': 'Seçilen döviz kuru mevcut değil',
    '提币数量不能小于等于0': 'Çekim miktarı 0\'dan küçük veya eşit olamaz',
    '提交失败，当前有未处理订单': 'Gönderim başarısız, işlenmemiş siparişler var',
    '提示': 'Bildirim',
    '提现不得大于限额': 'Çekim limiti aşamaz',
    '提现不得小于限额': 'Çekim limitin altında olamaz',
    '图片不得大于10M': 'Resim 10 MB\'tan büyük olamaz',
    '图片不得大于2M': 'Resim 2 MB\'tan büyük olamaz',
    '图片大小不能超过2M！': 'Resim boyutu 2 MB\'ı aşamaz!',
    '图片上传失败': 'Resim yükleme başarısız',
    '推荐码不正确': 'Referans kodu yanlış',
    '推荐人无权限推荐': 'Referans veren kişinin referans yetkisi yok',
    '委托数量(张)必填': 'Emir miktarı (sözleşme) zorunludur',
    '委托数量(张)不能小于等于0': 'Emir miktarı (sözleşme) 0\'dan küçük veya eşit olamaz',
    '未绑定谷歌验证器': 'Google Authenticator bağlı değil',
    '未绑定手机号': 'Telefon numarası bağlı değil',
    '未绑定邮箱': 'E-posta bağlı değil',
    '未发现授权记录': 'Yetkilendirme kaydı bulunamadı',
    '未实名认证，是否认证？': 'Doğrulanmadı. Şimdi doğrulansın mı?',
    '未授权访问': 'Yetkisiz erişim',
    '未找到符合条件的匹配订单': 'Eşleşen sipariş bulunamadı',
    '未找到匹配的收益记录': 'Eşleşen gelir kaydı bulunamadı',
    myComment: 'Yorumlarım',
    myPoint: 'Puanlarım',
    accountInfo: 'Hesap bilgileri',
    myBalance: 'Bakiyem',
    myCoupon: 'Kuponlarım',
    unused: 'Kullanılmamış',
    used: 'Kullanılmış',
    expired: 'Süresi dolmuş',
    expires: 'Geçerlilik tarihi',
    minSpend: 'En az',
    availableBalance: 'Kullanılabilir bakiye',
    personalDeposit: 'Bakiye',
    useDepositBalance: 'İndirim için bakiye kullan',
    depositDeduct: 'Bakiye kesintisi',
    useMaxDeposit: 'Tam kesinti',
    balanceHistory: 'Bakiye geçmişi',
    recordCount: 'Toplam {count} kayıt',
    depositType: 'İşlem türü',
    balanceAfter: 'Kalan bakiye',
    depositTypeRecharge: 'Bakiye yükleme',
    depositTypeAdjustment: 'Bakiye düzeltme',
    depositTypeOrderPayment: 'Sipariş ödemesi',
    depositTypeOrderRefunds: 'Sipariş iadesi',
    depositTypeDistributionCommission: 'Dağıtım komisyonu',
    depositTypeDistributionWithdrawal: 'Dağıtım çekimi',
    depositTypeOther: 'Diğer',
    income: 'Gelir',
    expense: 'Gider',
    description: 'Açıklama',
    myFootprint: 'Gezinme geçmişim',
    '无权限': 'Yetki yok',
    '无效的UID': 'Geçersiz UID',
    '系统参数错误': 'Sistem parametresi hatası',
    '系统存在相同[系统登录名]！': 'Sistemde aynı [giriş adı] zaten var!',
    '系统错误，请稍后重试': 'Sistem hatası, lütfen daha sonra tekrar deneyin',
    '下单不能小于最小金额限制': 'Sipariş minimum tutardan az olamaz',
    '校验IP不合法': 'Doğrulama IP\'si geçersiz',
    '新密码不能为空': 'Yeni şifre boş olamaz',
    '新密码不一致': 'Yeni şifreler eşleşmiyor',
    '新密码确认不能为空': 'Yeni şifre onayı boş olamaz',
    '行情获取异常，稍后再试': 'Piyasa verileri alınamadı, lütfen daha sonra tekrar deneyin',
    '验证类型不能为空': 'Doğrulama türü boş olamaz',
    '验证码不能为空': 'Doğrulama kodu boş olamaz',
    '验证码不正确': 'Doğrulama kodu yanlış',
    '验证码错误': 'Doğrulama kodu hatası',
    '页码不能小于等于0': 'Sayfa numarası 0\'dan küçük veya eşit olamaz',
    '页码不是整数': 'Sayfa numarası tam sayı değil',
    '已领取': 'Zaten alındı',
    '用户不存在': 'Kullanıcı mevcut değil',
    '用户名必须由数字和英文字母组成': 'Kullanıcı adı rakamlar ve Latin harflerinden oluşmalıdır',
    '用户名不存在': 'Kullanıcı adı mevcut değil',
    '用户名不符合设定': 'Kullanıcı adı gereksinimleri karşılamıyor',
    '用户名不能为空': 'Kullanıcı adı boş olamaz',
    '用户名参数为空': 'Kullanıcı adı parametresi boş',
    '用户名重复': 'Kullanıcı adı yinelenmiş',
    '用户剩余数量不足': 'Kalan kullanıcı miktarı yetersiz',
    '用户已跟随交易员': 'Kullanıcı işlemciyi zaten takip ediyor',
    '邮箱已绑定': 'E-posta zaten bağlı',
    '邮箱已绑定其他用户': 'E-posta zaten başka bir kullanıcıya bağlı',
    '余额不足': 'Bakiye yetersiz',
    shop_order_insufficientBalance: 'Hesap bakiyesi yetersiz',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Hesap anormal, C3 doğrulaması gerekli. Lütfen çevrimiçi müşteri hizmetleriyle iletişime geçin.',
    '找不到用户': 'Kullanıcı bulunamadı',
    flashSale: 'Flash İndirim',
    groupBuy: 'Grup alımı',
    groupBuying: 'Toplu alım',
    couponCenter: 'Kupon merkezi',
    pointMall: 'Puan mağazası',
    liveList: 'Canlı yayın',
    endsIn: 'Bitişe kalan',
    soldOut: 'Satıldı',
    people: 'kişi',
    joined: 'Katıldı',
    startGroup: 'Grup alımı başlat',
    getCoupon: 'Al',
    '直线关系，不能修改推荐': 'Doğrudan ilişki, referans değiştirilemez',
    '重复提交': 'Yinelenen gönderim',
    '转账币种不能为空': 'Transfer para birimi boş olamaz',
    '转账数量不能小于等于0': 'Transfer miktarı 0\'dan küçük veya eşit olamaz',
    '状态不能小于0': 'Durum 0\'dan küçük olamaz',
    '状态不是整数': 'Durum tam sayı değil',
    '资金密码必须6-12位': 'Fon şifresi 6-12 karakter olmalıdır',
    '资金密码不符合设定': 'Fon şifresi gereksinimleri karşılamıyor',
    '资金密码不能为空': 'Fon şifresi boş olamaz',
    '资金密码错误': 'Fon şifresi hatası',
    '资金密码长度不符合设定': 'Fon şifresi uzunluğu gereksinimleri karşılamıyor',
    'UID不能为空': 'UID boş olamaz',
    required: 'Bu alan zorunludur',
    nickname: 'Takma ad',
    enterNickname: 'Lütfen takma ad girin',
    gender: 'Cinsiyet',
    male: 'Erkek',
    female: 'Kadın',
    secret: 'Gizli',
    birthday: 'Doğum günü',
    selectDate: 'Tarih seç',
  cancelOrderMap: {
    0: "istemiyorum.",
    1: "Ürünü yanlış yerleştirdim",
    2: "Tekrarlanan sipariş",
    3: "Alma başarısız oldu",
    4: "Diğer sebepler",
  },
  "当前余额": "Mevcut bakiye",
  "请选择": "Lütfen seçiniz",
  "获取验证码": "Doğrulama kodunu al",
  "请输入验证码": "Lütfen doğrulama kodunu girin",
  "验证码": "Doğrulama kodu",
  "发送": "Gönder",
  "已发送，请注意查收":
    "Gönderildi, lütfen yanıtınızı kontrol edin",
  "仅能绑定一个收款地址!": "Sadece bir ödeme adresi bağlayabilirsiniz!",
  "绑定成功": "Başarıyla bağlandı",
  "提款地址绑定": "Para çekme adresi bağlama",
  "电商批发商场": "E-ticaret toptan pazarı",
  "请输入完整的支付密码!" : "Lütfen tam ödeme şifresini girin!",
  "用户未发表评论": "kullanıcı yorum yapmadı",
  "订单": "Emir",
  "备注": "Not",
  "下单成功，等待付款": "Sipariş başarıyla verildi, ödeme bekleniyor",
  "下单成功，付款成功": "Sipariş başarıyla verildi, ödeme başarılı oldu",
  "已发货，正在运输中": "Sevk edildi, nakliyede",
  "订单已取消，原因:手动发起取消订单": "Sipariş iptal edildi. Sebep: Siparişi manuel olarak iptal edin.",
  "订单已取消，原因:超时自动取消订单": "Sipariş iptal edildi. Sebep: Sipariş, zaman aşımına uğradığında otomatik olarak iptal edilecektir.",
  "商家已确认，已进入备货状态": "Satıcı onaylandı ve stok durumuna girdi.",
  "系统发货成功": "Sistem teslimi başarılı oldu",
  "订单已签收": "Sipariş Alındı",
  "发起退款申请": "Bir geri ödeme isteği başlatın",
  "退款成功": "Geri ödeme başarılı oldu",
  "退款失败": "Geri ödeme başarısız oldu",
  "订单退款成功": "Siparişin geri ödenmesi başarılı oldu",
  "订单退款失败": "Sipariş geri ödemesi başarısız oldu",
  "系统默认好评": "Sistem varsayılan olarak olumlu incelemeleri kullanır",
  "请输入关键字搜索": "Lütfen aramak için anahtar kelime giriniz",
  "猜你喜欢": "Sanırım hoşuna gitti",
  "订单已完成": "Sipariş tamamlandı",
  "热销推荐": "Sıcak Satış Önerisi",
  "头像选择": "Avatar Seçimi",
  "修改头像": "Avatarını değiştir",
  subOrder: "Siparişi Gönder",

  "mailboxCheck": "Lütfen doğru e-posta adresini girin",
  "switchLang": "Lütfen görüntülemek için başka bir dile geçin",
  "myCart": "alışveriş sepetim",
  "notQua": "Kalifikasyon koşulları karşılanmamıştır.",
  "noSmaller": "Uygulanan miktar şundan az olamaz:",
  "nomax": "Maksimum başvuru miktarı geçemez",
  "evaluationUploading": "Hala yüklenen resimleriniz var. Lütfen daha sonra tekrar deneyiniz",
  "evaluateInput": "resimlerle incele",
  "moneyOrderStatus": "Sipariş durumu",
  "coinBlock": "Döviz sözleşmesi",
  "dealing": "işlemde",
  "dealSuccess": "Başarılı",
  "dealFail": "Hata",
  "payCertificate": "Ödeme sertifikası",
  "handleFee": "Servis bedeli",
  "highOpinion": "İyi eleştiriler",
  "mediumOpinion": "Orta inceleme",
  "lowOpinion": "Kötü yorumlar",
  "hasImage": "Resimleri olan",
  "rechargeMethod": "Şarj modu",
  "scanAndDown": "QR Kodunu Tara UYGULAMAYI İndir",
  "receivedAddress": "makbuz adresi",
  "ActualLedger": "Gerçek makbuz",
  "view": "Görüş",
  "withdrawNum": "Nakit çekme miktarı",
  "rechargeNum": "Şarj miktarı",
  "date": "Tarih",
  "walletHistory": "Cüzdan geçmişi",
  "accountBalance": "Hesap bakiyesi",
  "accountReview": "Hesap özeti",
  "rated": "İncelendi",
  "receiver": "Alıcı",
  "orderStatus": "Durum",
  "orderTime": "Zaman",
  "tax": "Vergilendirme",
  "discount": "İndirim",
  "productInfo": "Ürün Bilgisi",
  "paramError": "parametre hatası",
  "orderInfo": "Sipariş Bilgisi",
  "rebuy": "Bir sipariş daha",
  "pleaseCorrectAddress": "Lütfen doğru para çekme adresini girin",
  "pleaseInputCorrectNumber": "Lütfen 0'dan büyük bir sayı girin",
  "vcodePass": "Doğrulama geçti!",
  "vcodeFail": "Kimlik doğrulama başarısız oldu, lütfen tekrar deneyin",
  "uploading": "yükleniyor...",
  "uploadSuccess": "Yüklendi başarılı",
  "uploadError": "Yükleme başarısız. Lütfen tekrar deneyin",
  "registerSuccess": "Kayıt başarılı",
  "pleaseSetMobileNumber": "Lütfen telefon numarasını ayarlayın",
  "unSelectedProduct": "Bir ürün seçmediniz",
  "loginSuccess": "Giriş başarılı",
  "pleaseSetAreaCode": "Aranacak ülke adını ve alan kodunu girin",
  "login": "Giriş yapmak",
  "register": "Kayıt",
  "logout": "çıkış",
  "noData": "Veri bulunamadı",
  "search": "Aramak",
  "historySearch": "Tarihsel arama",
  "empty": "Boş",
  "home": "Anasayfa",
  "favorableRate": "İyi yorumların oranı",
  "classification": "Kategori",
  "searchTips": "Kaynak arama/ürün/tedarikçi/sipariş",
  "dailyNewArrival": "Listelenen günlük yeni ürünler",
  "more": "Daha",
  "recommend": "Öneri",
  "recommendedProducts": "Önerilen ürünler",
  "recommendedStore": "Önerilen mağazalar",
  "buyNow": "Şimdi satın al",
  "addCart": "alışveriş sepetine ekle",
  "complex": "Birleşik",
  "price": "Fiyat",
  "retailPrice": "Perakende fiyatı",
  "originPrice": "Orijinal fiyat",
  "service": "Müşteri servisi",
  "collect": "Favoriler",
  "sold": "Satış hacmi",
  "pageviews": "tarama miktarı",
  "quantity": "Miktar",
  "freight": "Kargo",
  "shipping": "Nakliye",
  "ship": "Bot",
  "buyTips": "Siparişi verdikten sonra 24 saat içinde kargoya verilir. Aşağıdaki siparişler lojistik kontrol altındadır ve geç sevk edilebilir. Lütfen lojistik bilgilerine dikkat edin veya müşteri hizmetleri ile iletişime geçin.",
  "totalPrice": "Toplam fiyat",
  "addCartMessage": "Alışveriş sepetine başarıyla eklendi",
  "addCartMessageFaild": "Ürün zaten alışveriş sepetinde var.",
  "myAccount": "q hesabım",
  "buyHistory": "Satın alma kayıtları",
  "wishlist": "favori ürünler",
  "trackOrder": "Emir",
  "account": "Hesap:",
  "sellerZone": "Tüccar alanı",
  "beSeller": "Tüccar ol",
  "sellerPanelLogin": "Satıcı girişi",
  "footTip": "© Telif Hakkı {name} Ltd 2024",
  "footTips": "{name} Limited, Finansal Yürütme Otoritesi tarafından bir kredi komisyoncusu (713206) olarak yetkilendirilir ve düzenlenir ve yalnızca {name} Finansal Hizmetler olarak borç veren Home Retail Group CardServices Limited ile ilgilenir. {name} Finansal Hizmetleri, kredi sağlamak için Mali Davranış Otoritesi tarafından yetkilendirilmiş ve düzenlenmiştir (716148). Ev Perakende GrubuCard Services Limited, Birleşik Krallık'ta (04007072) Avebury, 489-499 Avebury Boulevard, Milton Keynes, Birleşik Krallık adresinde kayıtlıdır. MK9 2NW.",
  "item": "Madde",
  "checkout": "Sipariş vermek",
  "productDescription": "Ürün Açıklaması",
  "userEvaluation": "kullanıcı yorumları",
  "AllProducts": "Tüm ürünler",
  "followers": "Takip etmek",
  "sales": "Satış hacmi",
  "visitStore": "mağazayı ziyaret et",
  "authentic": "%100 Hakiki",
  "dayReturns7": "7 gün dönüş",
  "shippingDiscounts": "navlun indirimi",
  "safePayment": "Güvenli ödeme",
  "followed": "Takip etti",
  "dashboard": "Enstrüman paneli",
  "myOrder": "Benim siparişim",
  "setUp": "Kurmak",
  "successTips": "Başarılı",
  "copySuccess": "Çoğaltma başarılı",
  "balance": "Bakiye(USDT)",
  "sort": "Tip",
  "commodity": "Ürün",
  "browse": "Satış hacmi",
  "recharge": "şarj et",
  "commodityCollection": "Ürün koleksiyonu",
  "withdraw": "nakit çekme",
  "defaultAddress": "Varsayılan adres",
  "addNewAddress": "yeni adres ekleyin",
  "withdrawRecord": "Nakit çekme kaydı",
  "serialNumber": "sipariş numarası",
  "time": "Zaman",
  "amount": "Miktar",
  "processing": "işlemde",
  "fail": "Hata",
  "blockchainNetwork": "Blockchain ağı",
  "records": "Kayıt",
  "withdrawAddress": "Para çekme adresi",
  "withdrawInputTips": "Lütfen para çekme adresini girin",
  "copy": "çoğaltma",
  "enterTips": "Girin lütfen",
  "actualAccount": "gerçek hesap",
  "handlingFee": "Servis bedeli",
  "confirm": "Makbuzu onaylayın",
  "previous": "Önceki adım",
  "pleaseEnterAddress": "lütfen adresi giriniz",
  "pleaseEnterQuantity": "Lütfen miktar giriniz",
  "withdrawSuccess": "Siparişler başarıyla gönderildi",
  "saveQr": "QR kodunu kaydet",
  "pleaseEnterAmount": "Lütfen yeniden yükleme miktarını girin",
  "expectedArrival": "Beklenen varış",
  "currentRate": "cari döviz kuru",
  "uploadTips": "Ödeme belgesi (Ödeme ayrıntılarının ekran görüntüsünü yükleyin)",
  "clickUpload": "yüklemek için tıklayın",
  "uploadPhoto": "Lütfen fotoğraf yükleyin",
  "rechargeSuccessful": "Şarj başarılı",
  "rechargeTips": "\"Yeniden yükleme istemi: \"\"Lütfen gerçek aktarım miktarını doğru bir şekilde girin. Aksi takdirde, sistem onayı geçemeyebilir ve yeniden yükleme sürecini etkileyebilir.\"",
  "rechargeRecord": "Şarj kaydı",
  "all": "Tüm",
  "pending": "Ödenecek",
  "cancelled": "İptal edildi",
  "delivered": "Sevk edilecek",
  "confirmed": "Onaylanmış",
  "receipt": "alınacak",
  "harvested": "Kabul edilmiş",
  "comment": "gözden geçirilecek",
  "refund": "Geri ödeme/satış sonrası",
  "cancelOrder": "Siparişi iptal et",
  "cancelReason": "İptal sebebi",
  "cancelOrderTitle": "Lütfen bir sipariş iptal nedeni seçin",
  "returnOrderTitle": "Lütfen iade nedenini seçin",
  "refundInstructions": "Geri ödeme talimatları",
  "returnDetailTips": "Lütfen ürün hakkında yorum yapın",
  "cancel": "Siparişi iptal et",
  "cancelOrder1": "Ürün alınmadı",
  "cancelOrder2": "Sevmiyorum, istemiyorum",
  "cancelOrder3": "Satıcı yanlış malları gönderdi",
  "cancelOrder4": "sahte marka",
  "cancelOrder5": "Daha az gönderi, kaçırılan gönderi",
  "cancelOrder6": "Alınan ürün hasarlı",
  "cancelOrder7": "kalite sorunu var",
  "cancelOrder8": "Satıcıyla geri ödeme için pazarlık yapın",
  "cancelOrder9": "Diğer sebepler",
  "cancelOrderSuccess": "Sipariş başarıyla iptal edildi",
  "returnOrderSuccess": "Başarıyla gönder",
  "orderName": "İsim",
  "orderEmail": "E-posta",
  "orderAddress": "Adres",
  "orderNation": "Ülke",
  "orderState": "Durum",
  "orderCity": "Şehir",
  "orderPostCode": "Posta Kodu",
  "orderAmount": "Miktar",
  "orderPrefix": "Genel sipariş toplamı",
  "orderFee": "vergiler",
  "orderSpecification": "Şartname",
  "orderCommodity": "Ürün",
  "orderQuantity": "Miktar",
  "orderUnitprice": "Birim fiyat",
  "orderFreight": "Kargo",
  "orderTax": "Vergi",
  "orderTotal": "Toplam",
  "PaymentOrder": "Ödeme talimatı",
  "Evaluate": "Gözden geçirmek",
  "CancelOrder": "Siparişi iptal et",
  "RemindShip": "Sevkiyat için Hatırlat",
  "Refund": "Geri ödemek",
  "Submitareview": "İnceleme gönder",
  "Information": "Bilgi",
  "wrongPassword": "3 defadan fazla şifre hatası. Lütfen yarın tekrar deneyin.",
  "Operate": "Operasyon",
  "Item": "Öğeler)",
  "From": "İtibaren",
  "hint": "İpuçları",
  "CheckDetails": "Detayları göster",
  "Payment": "Ödeme",
  "Cancel": "İptal etmek",
  "refundSuccessfully": "Geri ödeme başarılı oldu",
  "pendingPayment": "Ödenecek",
  "pay": "Ödeme",
  "LoginPassword": "Giriş şifresi",
  "sure": "Elbette",
  "shippingAddress": "alıcı adresi",
  "transactionPassword": "İşlem Şifresi",
  "markDefaultAddress": "Varsayılan Gönderim adresi olarak işaretle",
  "edit": "Tarafından düzenlendi",
  "delete": "Silmek",
  "Opt": "Seçme",
  "piece": "Adet",
  "orderDetails": "Sipariş detayları",
  "shopCollection": "Mağazayı favorilere ekle",
  "addAddress": "yeni adres ekleyin",
  "signUp": "Kayıt",
  "loginTips": "Zaten hesabınız var mı?",
  "loginIn": "Giriş yapmak",
  "mobile": "Telefon yok",
  '购物车还没有商品': "Alışveriş sepetinde henüz ürün yok",
  '去购物': "Alışverişe başla",
  "modifyAddress": "Adresi değiştir",
  "desc": "Varsayılan adres olarak ayarla",
  "keep": "Sürdürmek",
  "onlineService": "Çevrimiçi hizmetler",
  "send": "Göndermek",
  "EsShop": "Online mağaza",
  "desc3": "işlem şifresini girin",
  "desc4": "işlem şifrenizi girin",
  "desc6": "İşlem şifrenizi tekrar girin",
  "setUpPayPaw": "İşlem şifresini ayarla",
  "setSuccess": "Kurulum başarılı",
  "confirmPayPaw": "İşlem şifresini onaylayın",
  "paymentSuccessful": "ödeme başarılı",
  "desc5": "Yanlış teslimat adresi? Temas etmek",
  "customeService": "çevrimiçi müşteri hizmetleri",
  "BackHome": "Ana sayfaya geri dön",
  "Checkorder": "Siparişi görüntüle",
  "ForgotPassword": "Parolayı mı unuttunuz?",
  "signIn": "Giriş yapmak",
  "noAccount": "Hesap numarası yok mu?",
  "pleaseEnterAccount": "Lütfen hesap numarasını girin",
  "pleaseEnterPassword": "Lütfen şifre giriniz",
  "password": "Şifre",
  "mobilePhone": "Telefon numarası",
  "pleaseEnterPhoneNumer": "Lütfen telefon numarasını ayarlayın",
  "setPassword": "Şifreyi belirle",
  "noDataFound": "Veri bulunamadı",
  "searchCountry": "Aranacak ülke adını ve alan kodunu girin",
  "pleaseEnterEmail": "Lütfen posta kutusunu ayarlayın",
  "invitationCode": "Davet Kodu",
  "plaeseEnterInvitaionCode": "Lütfen davet kodunu ayarlayın",
  "pleaseSetLoginPassword": "Lütfen giriş şifresini ayarlayın",
  "selectDeliveryAddress": "Gönderim adresini seçin",
  "totalOf": "Toplam",
  "items": "Öğe",
  "orderSummary": "Sipariş özeti",
  "paymentMethod": "Ödeme yöntemi",
  "Balance": "Denge",
  "payPal": "paypal",
  "notOpen": "Bu ödeme yöntemi bölgeniz için henüz açık değil",
  "mastercard": "MasterCard",
  "additional": "Ekstra",
  "handlingfee": "Servis ücreti gerekli",
  "goodsNumber": "ürün miktarı",
  "deliveryFee": "navlun",
  "totalNum": "Toplam",
  "new": "Yeni",
  "oldPassword": "Eski Şifre",
  "pleaseEnterOldPassword": "Lütfen eski şifreyi girin",
  "newPassword": "Yeni Şifre",
  "plaseeEnterNewPassword": "Lütfen yeni şifreyi girin",
  "confirmPassword": "Şifreyi Onayla",
  "plaseeENterConfirmPassword": "Lütfen onay şifresini girin",
  "twoPawword": "İki şifre aynı değil",
  "rechargeAddress": "Şarj adresi",
  "plaseEnterRechargeAddress": "Lütfen şarj adresini girin",
  "userCenter": "Kişisel merkez",
  "merchantSettled": "Tüccar girişi",
  "upNew": "Listelenen yeni ürün",
  "balanceNot": "Denge yeterli değil. Lütfen şarj edin.",
  "NoProductSelected": "Ürün henüz seçilmedi",
  "ShippingAddressNotSet": "Gönderim adresi belirlenmedi",
  "consigneeName": "Alıcının adı",
  "email": "E-posta:",
  "areaCode": "Uluslararası alan kodu",
  "phoneNumber": "Telefon numarası",
  "nation": "Ülke",
  "state": "İl/Eyalet/Eyalet",
  "city": "Şehir",
  "postCode": "Posta Kodu",
  "address": "Detaylı adres",
  "addAddressOrModifyAddress": "Yeni adres ekle/Adresi değiştir",
  "setAsTheDefaultAddress": "Varsayılan adres olarak ayarla",
  "proceed": "Devam etmek",
  "btnSure": "Onaylamak",
  "pleaseInput": "Girin lütfen",
  "allProduct": "Tüm ürünler",
  "myCommodityCollection": "favori ürünler",
  "myFollowedShops": "mağazayı takip et",
  "mySold": "Satılmış",
  "myPageviews": "tarama miktarı",
  "myPraiseRate": "İyi yorumların oranı",
  "myUnfollow": "takibi bırak",
  "inputNum": "Sayılar",
  "inpuEmailErro": "Lütfen doğru e-posta adresini girin",
  "goodsShip": "gönderi",
  "goodsShipTips": "Ürünler sipariş verildikten sonra 24 saat içerisinde kargoya verilir. Bir sonraki sipariş için lojistik kontrol varsa, sipariş gecikebilir. Lütfen siparişin lojistik bilgilerine dikkat edin veya müşteri hizmetleri ile iletişime geçin.",
  "goodsFreight": "navlun",
  "goodsFreeShipping": "Ücretsiz",
  "goodsFreightTips1": "1. Sınır ötesi ürün navlun kompozisyonu: navlun=sevk ücreti+ uzun mesafe navlun+ teslimat ücreti",
  "goodsFreightTips2": "2. Posta koşullarının sağlanmaması durumunda, navlun fiili koşullara göre ücretlendirilir.",
  "goodsFreightTips3": "3. Nihai yorumlama hakkı platforma aittir.",
  "pleaseValidPostCode": "Lütfen 4 haneden fazla girin",
  "pleaseValidEmail": "Lütfen doğru e-posta adresini girin",
  "pleaseValidPhone": "Lütfen doğru telefon numarasını girin",
  "productAvailable": "Bu ürün kaldırıldı",
  "validatorMaxNumber": "Tutar sınırı aşıyor",
  "validatorRequire": "Gerekli öğeler null olamaz",
  "validatorPhone": "Lütfen doğru telefon numarasını girin",
  "validatorEmail": "Lütfen doğru e-posta biçimini girin",
  "validatorPassword": "Şifre 6-12 hane veya harflerden oluşur(özel karakterler içerir)",
  "validatorSixNumber": "Lütfen 6 tam basamak girin",
  "validatorFourMoreNumber": "Lütfen 4-32 rakam veya harf kombinasyonu girin",
  "validatorIpRule": "Yanlış IP formatı",
  "validatorChineseAndEnglish": "Yalnızca Çince ve İngilizce, aralık girin: 8-64 karakter",
  "collectionSuccess": "Başarıyla favorilere ekle",
  "followedSuccess": "takip başarılı",
  "cancelSuccess": "İptal edildi başarılı",
  "加值": "Değer ekle",
  "提领": "Çekme",
  "平台人工发起退款": "Platform manuel olarak iade başlatır",
  "银行卡": "Banka kartı",
  "联系商家": "Tüccarla iletişime geçin",
  "evaluateOrder": "resimlerle incele",
  "evaluateOrderPlaceholder": "Lütfen ürünleri inceleyin",
  "operationSuccess": "İşlem başarılı oldu",
  "confirmReceiveGoods": "Ürünün alındığını onaylayın veya onaylayın",
  "evaluateOrderSuccess": "İnceleme başarılı oldu",
  "yesterday": "Dün",
  "notLogin": "Henüz giriş yapmadınız.",
  "delAllHistoryRecord": "Tüm geçmiş kaydını silmek istediğinizden emin misiniz?",
  "or": "Veya",
  "tipsRemindsText": "Gönderi hatırlatıldıktan sonra tüccar bir hatırlatma alacak",
  "tipsRemindsCount": "Sadece bir kez hatırlatılabilir.",
  "tipsRemindsMerchant": "Satıcılara hatırlat",
  "tipsRemindsSuccess": "Hatırlatma başarılı oldu",
  "noCartTips": "Alışveriş çantanız boş. Alışverişe başla.",
  "defaultRate": "Sistem varsayılan olarak olumlu incelemeleri kullanır",
  "prevPage": "Önceki sayfa",
  "nextPage": "Sonraki Sayfa",
  "returnApply": "İade talebi",
  "returnReason": "Geri ödeme nedeni",
  "returnAmount": "İade tutarı",
  "returnRemark": "İade talimatları",
  order: {
    "Cancel": "İptal etmek",
    "payment": "Şimdi öde",
    "remind": "Sevkiyat için Hatırlat",
    "return": "Ürün iadesi talebi",
    "evaluate": "Şimdi inceleyin",
    "logistics": "Lojistiği görüntüle",
    "noRefund": "geri ödemesiz",
    "refunding": "Geri ödeme devam ediyor",
    "refundSuccess": "Geri ödeme başarılı oldu",
    "refundFail": "Geri ödeme başarısız oldu",
    expressCompany: 'Kargo firması',
    trackingNo: 'Takip numarası',
    noOrderShipping: 'Gönderi bilgisi yok',
    noTransitSteps: 'Takip güncellemesi yok',
    logisticsLoadFail: 'Lojistik yüklenemedi. Lütfen daha sonra tekrar deneyin.',
  },
  "remindTitle": "Sevkiyat için Hatırlat",
  "remindContent": "Sevkiyat hatırlatıldıktan sonra, satıcı hatırlatıcıyı alır. Sadece bir kez hatırlatılabilir.",
  "remindSuccess": "Hatırlatma başarılı oldu",
  "remindRepeat": "Bu emir hatırlatıldı.",
  "noComments": "Şu anda inceleme yok",
  "storeSeach": "Bu mağazada ürün arayın",
  "storeSeachTips1": "senin için bulundu",
  "storeSeachTips2": "İlgili mağazalar bulundu",
  "storeSeachTips3": "Ev",
  "creditTit": "Kredi hizmetleri",
  "getCoupons": "Daha fazla kupon alın",
  "yourEmail": "e-posta adresiniz",
  "subscription": "Abonelikler",
  "paymethods": "Ödeme yöntemi",
  "footdec": "{name} global site kullanıcıları dünyanın {num} ülkesinden gelmektedir ve takas için {coin} kullanmaktadır. {coin}, dünya çapında bekleme ve uluslararası ücretler olmadan anında, düşük maliyetli işlemlere olanak tanıyan sınırsız bir işlemdir.",
  "custService": "Müşteri servisi",
  "helpLine": "çevrimiçi müşteri hizmetleri",
  "contactUs": "Bize Ulaşın",
  "partner": "kooperatif tedarikçileri",
  "buyRules": "alıcı kuralları",
  "客户端下载": "İstemci indir",
  "提现方式": "Para çekme yöntemi",
  "sellerRules": "satıcı politikası",
  "returnsAndEx": "İade ve Değişim",
  "servicePolicy": "hizmet politikası",
  "returnPolicy": "İade politikasi",
  "user_Center": "kullanıcı merkezi",
  "userReg": "kullanıcı kaydı",
  "orderTrack": "sipariş sorgusu",
  "purchageHistory": "Satın alım geçmişi",
  "myPurse": "Cüzdanım",
  "aboutUs": "Hakkımızda",
  "Recruitment": "Yetenekli kişileri bekleyin",
  "news": "haber bilgileri",
  "stateMent": "Modern kölelik beyanı",
  "binance": "Binance",
  "huobi": "huobi",
  "okx": "okx",
  "metaMask": "Meta Maske",
  "homeBannertips1": "Tüccar ol",
  "homeBannertips2": "Toplam komisyon",
  "homeBannertips3": "Maks.",
  "homeBannerbtn": "Şimdi Katıl",
  "homeDownloadtips1": "Sınır ötesi e-ticaret toptan alışveriş merkezi",
  "homeDownloadtips2": "Markaya özel teklif",
  "homeDownloadtips3": "Kesintisiz indirim",
  "homeDownloadtips4": "android indir",
  "homeDownloadtips5": "elma indir",
  "homeDownloadtips6": "APP'yi indirmek için QR kodunu tarayın",
  "homeIconTips1": "%100 Hakiki",
  "homeIconTips2": "7 gün dönüş",
  "homeIconTips3": "navlun indirimi",
  "homeIconTips4": "güvenli ödeme",
  "headerSearchTips": "Lütfen aramak için anahtar kelime giriniz",
  "collAccount": "kredi modu",
  "mine": "Bana ait.",
  "creditText1": "Başlangıç kredileri, borç para alma derdini çözüyor",
  "creditText2": "Başlangıç kredisi ve sermaye devir hizmetleri sağlamak",
  "creditWorry": "sorunsuz kredi",
  "creditQuota": "Esnek limit",
  "creditQuotaINFO": "100.000 ila 30.000.000, esnek limitli ve kısıtlamasız, maksimum kredi vadesi bir yıl.",
  "quickLoan": "hızlı kredi",
  "creditReview": "Denetimden en erken bir saat içinde geçin, incelemeden geçilirse kredi hemen serbest bırakılır.",
  "safe": "Güvenli ve endişesiz",
  "safeInfo": "İpotek yok, depozito yok, geri arama yok çünkü bu aslında özel bir mesele.",
  "about": "Hakkımızda",
  "aboutText1": "Önce müşteri iş felsefesine dayalı olarak finansal hizmetleri ödünç vermeye kararlıyız, müşteri sermaye devri sorununu çözme misyonunu üstleniyoruz. Kuruluşundan bu yana şirket, çok sayıda müşterinin sermaye devri sorununu çözmesine yardımcı olmuştur.",
  "aboutText2": "Limit: 100.000-30.000.000, düşük faizli esnek geri ödeme yöntemi, ön ödemesiz, çevrimiçi kredi, doğrulama için telefon aranması yok, gizli bilgiler ve aynı gün borç verme.",
  "contactUs1": "Seviye arkadaşlarınızdan borç para almak istemiyorsanız, lütfen bizimle iletişime geçin.",
  "committed": "Girişimci kredi hizmetlerine bağlı",
  "financial": "Mali endişelerinizi ele alın",
  "partnersTit": "İş Ortağı Çevrimiçi Ödünç Verme Platformu",
  "application": "Kredi başvurusu",
  "applicant": "Başvuru sahibi",
  "actualName": "Gerçek ad",
  "yourName": "Lütfen adı girin",
  "term": "kredi süresi",
  "applicationAmount": "Talep edilen miktar",
  "rates": "kredi faiz oranı",
  "loanMethod": "kredi modu",
  "accountB": "Hesap bakiyesi",
  "countryOf": "Milliyet",
  "myloan": "kredim",
  "applyLoan": "kredi başvurusu",
  "loaned": "ödünç",
  "interest": "Tahakkuk eden faiz",
  "esRepayment": "tahmini geri ödeme",
  "loanHistory": "kredi kaydı",
  "applicantDate": "Başvuru tarihi",
  "repayment": "geri ödeme",
  "cycle": "geri ödeme döngüsü",
  "fixedRate": "sabit faiz oranı",
  "successLoan": "Kredi başarılı oldu",
  "Reapply": "yeniden başvur",
  "borrow": "Kredi başarısız oldu",
  "applicantIn": "Uygulama devam ediyor",
  "repaid": "geri ödeme",
  "overdue": "vadesi geçmiş",
  "estirepay": "tahmini geri ödeme",
  "loanDays": "Ödünç verilen gün sayısı",
  "reAmount": "geri ödeme tutarı",
  "repay": "geri ödeme modu",
  "entRepay": "Geri ödemeyi onayla",
  "foryourmoney": "Borç para sıkıntısı çekiyorsanız, borç alacak yer bulamıyorsanız veya arkadaşlarınızdan borç para almaktan utanıyorsanız, bizimle iletişime geçebilirsiniz. Şüphelerinizi istediğiniz zaman yanıtlamak için tüm profesyonel hizmet sürecine sahibiz. Amacımız, müşterilerin hızlı ve güvenli bir şekilde kullanabilmesi için her bir krediyi şeffaf hale getirmektir.",
  "onlineApplin": "Çevrimiçi başvurun",
  "businessloan": "Başlangıç kredisi başvurusu",
  "selectCountry": "Lütfen bir uyruk seçin",
  "selectPeriod": "Lütfen bir dönem seçin",
  "passPortImg": "Kimlik No./Pasaport No.",
  "uploadId": "Sertifika fotoğrafı/pasaport yüklemesi",
  "readAndAgree": "okudum ve kabul ediyorum",
  "loanAgree": "Kredi anlaşması",
  "submitApplica": "başvurunun sunulması",
  "photoExample": "Fotoğraf çekme örneği",
  "discounted": "indirimli ürünler",
  "days": "gün",
  "privacyPolicy": "Gizlilik Politikası",
  "delivery": "Teslimat ve teslim alma",
  "checkAgreement": "Lütfen sözleşmeyi işaretleyiniz!",
  "businessPhone": "İş telefonu",
  "businessEmail": "Kurumsal E-posta",

  "提交失败": "Gönderilemedi",
  "充值金额不能小于1": "Şarj miktarı 1'den az olamaz (iki ondalık basamak dahil)",
  "请切换其他语言后查看": "Lütfen görüntülemek için başka bir dile geçin",
  "我的购物车": "alışveriş sepetim",
  "推荐商品": "Önerilen ürünler",
  "猜你喜欢": "Sanırım hoşuna gitti.",
  "暂无店铺": "mağaza bulunamadı",
  "添加失败": "Gönderilemedi. Lütfen daha sonra tekrar deneyiniz",
  "提交订单": "sipariş gönderimi",
  recommendclass: "Tavsiye Kategorisi",
  "滑动验证": "Kaydırma doğrulaması",
  "最多上传9张图片":"En fazla 9 fotoğraf yükleme",
  "账号注销":"Hesap iptali",
  "确定注销":"İptal etmek istediğinizden emin misiniz?",
  "您的账号":"Hesabınız",
  "为什么要离开":"Neden ayrılmak istiyorsun?",
  "您还有余额,不能注销账号":"Hesabınızda bakiye var, hesabınızı iptal edemezsiniz!",
  "请输入注销理由":"Lütfen iptal nedeninizi girin",
  "您确认要注销吗?":"Hesabınızı iptal etmek istediğinizden emin misiniz?",
  "我再考虑下":"Daha sonra düşünüyorum",
  "同意注销": "İptal etmeyi kabul ediyorum",
  "注销成功":"İptal başarılı",
  "App下载(买家端)": "App indirme (alıcı tarafı)",
  "App下载(卖家端)": "App indirme (satıcı tarafı)",
  "最多包含10位小数": "En fazla 10 ondalık basamak içerebilir",
  "加密货币": "Şifreli para birimi",
  "企业电话": "Kurumsal telefon",
  "职业机会": "İş gereksinimleri",
  "银行卡": "banka kartı",
  "充值币种": "Şarj para birimi",
  "充值金额": "Şarj miktarı",
  '参数缺失': "Parametre eksik",
  '充值数量必填': "Şarj miktarı gereklidir",
  "充值金额不得小于": "Şarj miktarı 1'den az olamaz (iki ondalık basamak dahil)",
  "充值金额不得大于": "Şarj miktarı 100'den fazla olamaz (iki ondalık basamak dahil)",
  "长时间未付款，系统自动取消订单": "Uzun süre ödeme yapılmadı, sistem siparişi otomatik olarak iptal eder",
  "请先选择币种": "Lütfen önce para birimi seçin",
  "开户行": "Banka hesabı",
  "请输入开户行名称": "Lütfen banka hesabı adını girin",
  "银行卡号": "Banka kartı numarası",
  "点击去支付": "Ödemeye gitmek için tıklayın",
  "企业证明": "Şirket kanıtı",
  "请输入银行卡号": "Lütfen banka kartı numarasını girin",
  footTipTikTok:'BizSpring Alışveriş Merkezi ©️2024 Telif Hakkı',
  TikTokFoot:"BizSpring Mall, BizSpring ve Asya'nın en büyük toptan ticaret şirketi Alibaba'nın ortaklaşa kurduğu küresel bir kısa video sosyal platformdur. Küresel bir e-ticaret platformudur ve dünyada Toronto, Kanada, Los Angeles ve Chiba, Japonya'da bulunan kendi kendine çalışan üç akıllı depoya sahiptir. Uygulamada satılan ürünler arasında Japonya, Güney Kore, Çin ve diğer Asya ülkelerinden popüler ürünler yer alıyor. Şu anda toplam sayı 50.000'i aştı ve hızla büyümeye devam ediyor.",
  "cancelInfo":"uyarmak! Lütfen hesabı iptal ederken dikkatli olun.Eğer hesabı artık kullanmıyorsanız [İptal Etmeyi Kabul Ediyorum] seçeneğine tıklayabilirsiniz.İptalin ardından birkaç gün içinde kayıt olamayabilirsiniz."
,
  "getCouponSuccess": "Başarıyla alındı",
  "liveRooms": "Canlı Odalar",
  "liveStreaming": "Canlı",
  "notStarted": "Başlamadı",
  "finished": "Bitti",
  "myPoints": "Puanlarım",
  "searchGoods": "Ürün Ara",
  "points": "Puan",
  "point": "Puan",
  "stock": "Stok",
  "spec": "Özellik",
  "exchangeNow": "Şimdi Değiştir",
  "currentPoint": "Puanlarım",
  "pointNotEnough": "Yetersiz puan"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "土耳其语(tr)",
    "addImageHint": "(Lütfen görsel ekleyin)",
    "deleteNode": "Sil",
    "topPos": "Üst {n}",
    "col": "Sütun {n}",
    "pos": "Konum {n}",
    "decoType_container": "Kapsayıcı",
    "decoType_title": "Başlık metni",
    "decoType_richText": "Zengin metin",
    "decoType_notice": "Duyuru",
    "decoType_blank": "Boşluk",
    "decoType_banner": "Döngü banner",
    "decoType_imageSingle": "Tek görsel",
    "decoType_imageMulti": "Çoklu görsel",
    "decoType_video": "Video",
    "decoType_goodsRecommend": "Önerilen ürünler",
    "decoType_goodsSelection": "Ürün seçkisi",
    "decoType_seckill": "Flaş indirim",
    "decoType_groupBuy": "Grup alışverişi",
    "decoType_coupon": "Kupon",
    "decoType_searchNav": "Arama gezinmesi",
    "decoType_search": "Arama kutusu",
    "decoType_searchBox": "Arama kutusu",
    "decoType_categoryNav": "Kategori gezinmesi",
    "decoType_goodsCategory": "Ürün kategorisi",
    "decoType_navIconRow": "Gezinme simgeleri",
    "decoType_imageScroll": "Görsel kaydırma",
    "decoType_pageBanner": "Sayfa banner'ı",
    "decoType_tabs": "Sekmeler",
    "decoType_brand": "Marka",
    "decoType_storeRecommend": "Önerilen mağazalar",
    "decoType_hotSelection": "Popüler seçki",
    "decoType_footerLinkGroup": "Alt bilgi bağlantıları",
    "decoType_partnerLogoRow": "Ortaklar",
    "decoType_icpInfo": "ICP bilgisi",
    "decoType_topNavMenu": "Üst gezinme",
    "decoType_logoBlock": "Logo",
    "decoType_langSwitcher": "Dil",
    "decoType_currencySwitcher": "Para birimi",
    "decoType_loginBlock": "Giriş",
    "decoType_cartIcon": "Sepet",
    "decoType_messageIcon": "Mesajlar",
    "seckillPrice": "Flaş fiyat",
    "seckillTag": "Flaş indirim",
    "seckillCountdown": "Bitişe kalan",
    "seckillNotStarted": "Yakında",
    "seckillRushing": "Devam ediyor",
    "seckillWillStart": "Yakında",
    "seckillBuy": "Hemen al (flaş)",
    "groupPrice": "Grup fiyatı",
    "groupRequiredNum": "kişi gerekli",
    "noGroupBuy": "Tek al",
    "groupRule1": "1. Ürün seç",
    "groupRule2": "2. Grup başlat",
    "groupRule3": "3. Grup tamam → kargo",
    "marketingMoneyOff": "İndirim",
    "marketingFreeShipping": "Ücretsiz kargo",
    "marketingGift": "Hediye",
    "marketingCoupon": "Kupon",
    "marketingGroup": "Grup alışverişi",
    "marketingSeckill": "Flaş indirim",
    "marketingExpired": "Kampanya sona erdi",
    "marketingNotActive": "Kampanya aktif değil",
    "alreadyGotCoupon": "Alındı",
    "couponReceived": "Alındı",
    "hotSearch": "Popüler arama:"
}